import { z } from 'zod'

const nonNegativeIntSchema = z.number().int().min(0)
const positiveIntSchema = z.number().int().min(1)

const formatIssuePath = (path: Array<string | number>) =>
  path.reduce((acc, part) => {
    if (typeof part === 'number') {
      return `${acc}[${part}]`
    }
    return acc ? `${acc}.${part}` : part
  }, '')

const formatValidationError = (endpoint: string, error: z.ZodError) => {
  const firstIssue = error.issues[0]
  if (!firstIssue) {
    return `Invalid ${endpoint} response`
  }

  const path = formatIssuePath(firstIssue.path)
  const target = path ? `"${path}"` : 'payload'
  return `Invalid ${endpoint} response: ${target} ${firstIssue.message}`
}

const parseWithSchema = <T>(schema: z.ZodType<T>, payload: unknown, endpoint: string): T => {
  const result = schema.safeParse(payload)
  if (!result.success) {
    throw new Error(formatValidationError(endpoint, result.error))
  }
  return result.data
}

export { nonNegativeIntSchema, positiveIntSchema, parseWithSchema }
